import { message, Row } from 'antd';
import { debounce } from 'lodash';

import { useEffect, useState } from 'react';

import {
  Form,
  FormItem,
  FormItemInput,
  FormItemSelect,
} from '../../../../components/index';

import { formatTerminalToSave } from '../../../../utils/formatters';
import { isNullOrUndefined } from '../../../../utils/utils';
import { FormItemsWrapper } from '../company/companyForm';
import { RegisterHeaderForm } from '../registerHeaderForm';
import {
  useCreateTerminalMutation,
  useDeleteTerminalMutation,
  useUpdateTerminalMutation,
} from '../../../../services/terminalApi';
import { TerminalType } from '../../../../types';
import { useGetPortsQuery } from '../../../../services/vesselApi';

type TerminalFormProps = {
  name: string;
  onClose: () => void;
  selectedTerminal: any;
  onSaveTerminal: () => void;
  setQueryPage: (page: number) => void;
};
export function TerminalForm(props: TerminalFormProps) {
  const { name, onClose, selectedTerminal, onSaveTerminal, setQueryPage } =
    props;
  const [
    createTerminal,
    { isSuccess: isSuccessSaveTerminal, isError: isErrorSaveTerminal },
  ] = useCreateTerminalMutation();
  const [
    updateTerminal,
    { isSuccess: isSuccessUpdateTerminal, isError: isErrorUpdateTerminal },
  ] = useUpdateTerminalMutation();
  const [
    deleteTerminal,
    { isSuccess: isSuccessDeleteTerminal, isError: isErrorDeleteTerminal },
  ] = useDeleteTerminalMutation();

  const [searchLastPort, setSearchLastPort] = useState({});
  const [selectedLastPortCountry, setSelectedLastPortCountry] =
    useState<string>();
  const [selectedLastPort, setSelectedLastPort] = useState(Object);
  const { data: lastPortsData, isLoading: isLoadingLastPortData } =
    useGetPortsQuery(searchLastPort);

  function validatePortlot(terminal: TerminalType): boolean {
    if (isNullOrUndefined(terminal.antaq_name)) {
      message.error('É necessario informar pelo menos o nome.');
      return false;
    }
    return true;
  }

  async function handleFormSubmit(values: any) {
    if (!validatePortlot(values)) return;
    let savedTerminal;
    if (selectedTerminal) {
      savedTerminal = await updateTerminal(formatTerminalToSave(values));
    } else {
      savedTerminal = await createTerminal(formatTerminalToSave(values));
    }
    if ('data' in savedTerminal) {
      onSaveTerminal();
    }
  }

  async function onDeleteTerminal() {
    if (selectedTerminal && selectedTerminal.id) {
      setQueryPage(1);
      await deleteTerminal(selectedTerminal.id);
    }
  }
  useEffect(() => {
    if (isSuccessSaveTerminal || isSuccessUpdateTerminal) {
      message.success('Terminal salvo');
      onClose();
    } else if (isErrorSaveTerminal || isErrorUpdateTerminal) {
      message.error(
        'Ocorreu um erro ao salvar o terminal, se o erro persistir entre em contato com o suporte'
      );
    }
  }, [
    isSuccessSaveTerminal,
    isErrorSaveTerminal,
    isSuccessUpdateTerminal,
    isErrorUpdateTerminal,
  ]);

  useEffect(() => {
    if (isSuccessDeleteTerminal) {
      message.success('Terminal excluído');
      onClose();
      onSaveTerminal();
    } else if (isErrorDeleteTerminal) {
      message.error(
        'Ocorreu um erro ao excluir o terminal, se o erro persistir entre em contato com o suporte'
      );
    }
  }, [isSuccessDeleteTerminal, isErrorDeleteTerminal]);

  function onSearchLastPortByName(val: string) {
    setSearchLastPort({
      name: val,
      countryCode: selectedLastPortCountry,
    });
  }

  function onSelectLastPort(option: string) {
    const portObject = lastPortsData?.results.find((port) => {
      return port.id === option;
    });
    setSelectedLastPort({ ...portObject });
  }

  function onClearSelectedLastPort() {
    setSelectedLastPort({});
  }

  return (
    <Form
      name={name}
      layout="vertical"
      onFinish={handleFormSubmit}
      initialValues={selectedTerminal || {}}
    >
      <RegisterHeaderForm
        onClose={onClose}
        formName={name}
        allowDelete={!!selectedTerminal}
        onDelete={onDeleteTerminal}
      >
        {selectedTerminal ? (
          <div className="title">{selectedTerminal.name}</div>
        ) : (
          <div className="title">Novo Terminal</div>
        )}
      </RegisterHeaderForm>
      <FormItemsWrapper>
        <Row>
          <FormItem noStyle name="id" />
          <FormItemInput
            label="COD. ANTAQ"
            name="antaq_code"
            placeholder="código ANTAQ"
          />
        </Row>
        <Row gutter={16}>
          <FormItemInput
            colSpan={12}
            label="Nome ANTAQ"
            name="antaq_name"
            placeholder="NLA"
            maxLength={100}
          />
        </Row>
        <Row>
          <FormItemInput
            label="COD. Mercante"
            name="merchant_code"
            placeholder="código ANTAQ"
          />
        </Row>
        <Row gutter={16}>
          <FormItemInput
            colSpan={12}
            label="Nome Mercante"
            name="merchant_name"
            placeholder="NLA"
            maxLength={100}
          />
        </Row>
        <Row gutter={16}>
          <FormItemSelect
            colSpan={8}
            name="port_bi_trigram"
            label="Porto"
            allowClear
            showSearch
            onSearch={debounce((e) => onSearchLastPortByName(e), 400)}
            onSelect={onSelectLastPort}
            onClear={onClearSelectedLastPort}
            dataList={lastPortsData?.results
              .slice()
              .sort((a, b) => a.name.localeCompare(b.name))}
            isLoading={isLoadingLastPortData}
            notFoundContent="Nenhum porto encontrado para o filtro informado"
          />
        </Row>
      </FormItemsWrapper>
    </Form>
  );
}
